import { api, type Ben, type Gorev, type KendiOgrenciKaydi } from "../api";
import { oturum } from "../oturum-durumu";
import type { IndexedDbDeposu } from "./indexeddb-depo";

/** F-STV-11 — saklı oturum ve önbellekteki görevler sahiplik kanıtı değildir. */
export async function karantinayiKurtar(
  depo: IndexedDbDeposu,
  kilitGecerli = () => true,
): Promise<void> {
  if (!(await depo.karantinadakiler()).length) return;
  const nesil = oturum.nesil;
  const sahip = oturum.kullaniciId;
  const gecerli = () =>
    kilitGecerli() && oturum.nesil === nesil && oturum.kullaniciId === sahip && !oturum.kapali;
  if (!sahip || !gecerli()) return;
  const ben = await api<Ben>("/auth/ben", { taze: true });
  if (!gecerli() || !ben.girisYapildi || ben.userId !== sahip || !ben.ogrenciMi) return;
  const ogrenci = await api<KendiOgrenciKaydi>("/ogrenciler/ben", { taze: true });
  if (!gecerli()) return;
  const gorevler = await api<Gorev[]>(`/calisma/ogrenci/${encodeURIComponent(ogrenci.id)}/hafta`, {
    taze: true,
    sorgu: { tarih: new Date().toISOString() },
  });
  if (gecerli())
    await depo.karantinayiGeriAl(sahip, ogrenci.id, new Set(gorevler.map((g) => g.id)), gecerli);
}
